<template>
<div class="process-forms">
    <el-form size="mini" label-width="120px">
        <div class="form-content">
            <div class="content-form-left">
                <el-card class="box-card" shadow="always">
                    <div slot="header" class="clearfix">
                        <span>项目表单列表</span>
                    </div>
                    <el-collapse v-if="isShowForms" v-model="collapseActiveName" @change="handleChange" accordion>
                        <el-collapse-item v-for="(form, index) in forms" :key="form.id" :title="form.formName" :name="form.id">
                            <template slot="title">
                              <div class='el-collapse-title'>
                                  <span>{{form.formName}}</span>
                              </div>
                            </template>
                            <el-form label-width="165px" :ref="'customForm'+index" >
                                <FieldItem v-for="(field,index2) in form.fieldsList" :findex="index2" :formId="form.id" :key="field.fieldId" :field="field" :formData="formData[index].values" :colSpan="form.colSpan" :fieldsList="form.fieldsList"/>
                            </el-form>
                        </el-collapse-item>
                    </el-collapse>
                </el-card>
            </div>
        </div>
    </el-form> 
</div>
</template>

<script>
    import { isEmpty } from 'lodash';
    import { getTimeTemplateInstanceForms } from '@/data-model';
    
    export default {
        components: {
        },
        data () {
            return {
                isShowForms: false,
                collapseActiveName: '',
                forms: [],
                formData: [],
                loadTimer: ''
            };
        },
        props: {
            timeTemplateInstanceId: {
                type: String,
                default: ''
            }
        },
        computed: {
        },
        created () {
            this._initFormsData();
        },
        methods: {
            async _initFormsData () {
                this.isShowForms = false;
                let tempFormsObj = await getTimeTemplateInstanceForms({
                    timeTemplateInstanceId: this.timeTemplateInstanceId
                });
                // console.log(tempFormsObj);
                let structure = [];
                if (tempFormsObj) {
                    let isHasVal = false;
                    let taskIdx = 0;
                    let objModelFormStructure = tempFormsObj.structure;
                    if (objModelFormStructure) {
                        objModelFormStructure.forEach(form => {
                            structure.push(form);
                        });
                    }
                    if (!isHasVal) {
                        await this.initAllDefaultVal(structure);
                    }
                    this.collapseActiveName = tempFormsObj.structure.length > 0 ? tempFormsObj.structure[0].id : '';
                    if (this.formData.length > 0) {
                        this.isShowForms = true;
                    }
                }
                this.forms = structure;
            },
            async initAllDefaultVal (structure) {
                structure.forEach(element => {
                    this.initDefaultVal(element);
                });
            },
            async initDefaultVal (element) {
                let fieldsList = element.fieldsList;
                let values = {};
                for (let index = 0, len = fieldsList.length; index < len; index++) {
                    const element = fieldsList[index];
                    values[element.id] = '';
                }
                this.formData.push({
                    formId: element.id,
                    values: values,
                    colSpan: element.colSpan ? element.colSpan : 1,
                    ext1: element.ext1 ? Number(element.ext1) : 0
                });
            },
            handleChange (val) {
                // console.log(val);
            },
            _getTemporaryFormInstance (sourceForms) {
                let temporaryFormData;
                if (sourceForms && sourceForms.instance) {
                    try {
                        let strTemporaryData = sourceForms.instance;
                        let objTemporaryData = JSON.parse(strTemporaryData);
                        temporaryFormData = objTemporaryData;
                    } catch (error) {
                        console.error('解析任务表单数据异常：', error);
                    }
                }
                return temporaryFormData;
            }
        }
    };
</script>
<style lang="less">
  .process-forms {
    .el-collapse-title {
        color: #4ebe17;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > .el-button {
            margin-right: 10px;
        }
    }
    .form-content{
      .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
        margin-bottom:2px
      }
      .el-form-item__label{
        color: #333;
        font-weight: 700;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/process/TimeConfig/TimeConfigDetail/TimeTemplateInstanceForms.vue